export default __webpack_public_path__ + "static/media/CAL40250.26d59e2f.jpg";